/*
* PdfHorizontalLineContent.js
* Created on 22-11-2017
* @author Olivier for &ranj
* 
* Draws a horizontal line (used mostly below the page title at the start of a PDF section)
*/

import { isNull } from "../../../util/TypeUtil";
import PdfConfig from "../../PdfConfig";
import AbstractPdfContent from "./AbstractPdfContent";

export default class PdfHorizontalLineContent extends AbstractPdfContent {
    constructor(pdfConfig, style) {
        super(style);

        this._lineHeight = 1;
        this._lineColor = [0, 0, 0];

        //set the width to PAGE_WIDTH by default
        if (isNull(style.width)) {
            style.width = pdfConfig.pageWidth;
        }

        this.setPropertiesFromObject(style);
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("size"): this._lineHeight = obj[property]; break;
                    case ("color"): this._lineColor = obj[property]; break;
                }
            }
        }
    }

    calculateBounds(doc) {
        this.setHeight(this._lineHeight);
    }

    printToDocument(doc, x, y) {
        //console.info("Drawing line at " + x + ", " + y);

        let top = y + this._padding[0];
        let left = x + this._padding[3];


        doc.setDrawColor(this._lineColor[0], this._lineColor[1], this._lineColor[2]);
        doc.rect(left, top, this._width, this._lineHeight - 0.5, 'FD');
    }
}